import { render, staticRenderFns } from "./DeliverySubsidy.vue?vue&type=template&id=7f7c5396&"
import script from "./DeliverySubsidy.vue?vue&type=script&lang=js&"
export * from "./DeliverySubsidy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports